import Avatar from '../assets/Matron.png';
import Avatar2 from '../assets/Prac.png';
import Avatar3 from '../assets/testimonialDoctor.png';
// import Avatar3 from '../assets/nurse mary.png';
const testimonial = [
  {
    id: 0,
    image: Avatar,
    name: 'Matron Nwankwo',
    testimonial:
      'LifeBank has improved our ability to save lives. They understand the importance of providing safe, quick, & reliable medical supplies.',

    placeOfWork: 'Chief Matron, Motayo Hospitals, Lagos',
  },
  
  {
    id: 1,
    image: Avatar2,
    name: 'Cynthia Egbai',
    testimonial:
      "Nerve by LifeBank has saved us money and headaches. We get high-quality medical supplies at the best market price",

    placeOfWork: 'Practice Manager, First Cardiology Consultants.',
  },
];
export default testimonial;
